import { render, staticRenderFns } from "./MybenFeature.vue?vue&type=template&id=018636ac"
import script from "./MybenFeature.vue?vue&type=script&lang=js"
export * from "./MybenFeature.vue?vue&type=script&lang=js"
import style0 from "./MybenFeature.vue?vue&type=style&index=0&id=018636ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports